module.exports = __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmEU9fCRc4EsA.378698af.woff2";